/**
 * Preferências de exibição **por navegador** — e só isto.
 *
 * A linha que separa o que mora aqui do que mora no servidor:
 * - aqui entram conveniências locais que não valem uma ida ao banco e cuja perda não machuca: a
 *   última aba aberta, uma seção recolhida, a escolha de tema;
 * - 🚨 **nunca** entram token de acesso, dado de cliente, CPF/CNPJ nem nada que o servidor seja a
 *   autoridade sobre. O access token vive em memória (`lib/auth.ts`), por decisão de segurança.
 *
 * Toda leitura e escrita vai dentro de `try`: em janela privada, com dados do site bloqueados ou em
 * modo quiosque, o acessador **lança** em vez de devolver vazio — e uma preferência de enfeite não
 * pode derrubar a tela.
 */

const PREFIXO = 'triplice:';

export function lerPreferencia(chave: string): string | null {
  try {
    return window.localStorage.getItem(PREFIXO + chave);
  } catch {
    return null;
  }
}

export function gravarPreferencia(chave: string, valor: string): void {
  try {
    window.localStorage.setItem(PREFIXO + chave, valor);
  } catch {
    // Sem armazenamento disponível: a preferência simplesmente não é lembrada.
  }
}

export function apagarPreferencia(chave: string): void {
  try {
    window.localStorage.removeItem(PREFIXO + chave);
  } catch {
    // idem
  }
}

/** Chaves em uso, num lugar só — evita duas telas gravando em `'tema'` e `'Tema'`. */
export const CHAVES_PREFERENCIA = {
  tema: 'tema',
} as const;
